import { render, staticRenderFns } from "./LanguagePickerCmp.vue?vue&type=template&id=4e3265e8&"
import script from "./LanguagePickerCmp.vue?vue&type=script&lang=js&"
export * from "./LanguagePickerCmp.vue?vue&type=script&lang=js&"
import style0 from "./LanguagePickerCmp.vue?vue&type=style&index=0&id=4e3265e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports